import { Command } from 'commander';
import chalk from 'chalk';
import fs from 'fs/promises';
import api from '../services/api';
import ux from '../utils/ux';
import asyncErrorWrapper from '../utils/async-error-wrapper';
import output from '../utils/output-writer';

const fetchTeleportContext = new Command('fetch-teleport-context')
  .description(
    'Fetch the full context Wild Moose holds for an alert investigation, as structured data'
  )
  .option(
    '-e, --enrichment-link <enrichmentLink>',
    'Slack link to the enrichment message to fetch. Preferred over --alert-link'
  )
  .option(
    '-l, --alert-link <alertLink>',
    'Slack link to the alert message the enrichment was produced for'
  )
  .option('-o, --output-path <outputPath>', 'File path to write the output to')
  .action(
    asyncErrorWrapper(
      async ({
        alertLink,
        enrichmentLink,
        outputPath,
      }: {
        alertLink?: string;
        enrichmentLink?: string;
        outputPath?: string;
      }) => {
        if ([enrichmentLink, alertLink].filter((link) => link).length !== 1) {
          throw new Error(
            'Pass exactly one of --enrichment-link or --alert-link'
          );
        }

        const result = await ux.runWithProcessingIndicator({
          msg: `Fetching teleport context for ${chalk.green(enrichmentLink ?? alertLink)}`,
          func: async () =>
            api.fetchTeleportContext({ alertLink, enrichmentLink }),
        });

        const resultJson = JSON.stringify(result, null, 2);
        if (outputPath) {
          await fs.writeFile(outputPath, resultJson, 'utf8');
          output.info(`Output written to ${outputPath}`);
        } else {
          output.info(resultJson);
        }
      }
    )
  );

export default fetchTeleportContext;
